<template>
  <div id="app"
       :class="{ 'no-cursor' : !isMobile }"
       @mousemove="emitMouseMove"
       @mousedown="emitMouseDown"
       @mouseup="emitMouseUp"
  >
    <custom-cursor v-if="!isMobile" />
    <router-view />
    <monitor-mosaic-transition v-if="vWidth >= 992" />
    <mobile-mosaic-transition v-else />
    <contact-modal />
    <tooltip />
  </div>
</template>
<script>
import CustomCursor from '@/components/custom-cursor'
import debounce from 'lodash.debounce'
import { mapState } from 'vuex'
import MonitorMosaicTransition from '@/components/mosaics/monitor-mosaic-transition'
import MobileMosaicTransition from '@/components/mosaics/mobile-mosaic-transition'
import ContactModal from '@/components/contact-modal'
import Tooltip from '@/components/tooltip'

export default {
  name: 'App',
  components: {
    CustomCursor,
    MonitorMosaicTransition,
    MobileMosaicTransition,
    ContactModal,
    Tooltip
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['cursorState', 'isMobile', 'currentPreviewIndex', 'vWidth', 'isContactModalOpen'])
  },
  methods: {
    emitMouseMove (e) {
      this.$root.$emit('cursor-move', e)
    },
    emitMouseDown (e) {
      this.$root.$emit('mouse-down', e)
    },
    emitMouseUp (e) {
      this.$root.$emit('mouse-up', e)
    }
  },
  mounted () {
    this.$root.$on('display-main-text-background', () => { this.isBackgroundTextVisible = true })
    this.$root.$on('change-welcome-text-background', () => {
      this.index += 1
    })
    window.onresize = debounce(() => {
      this.$store.dispatch(this.$GET_VIEWPORT_DIMENSIONS)
      this.$root.$emit('resize')
    }, 100)
  }
}
</script>
<style lang="sass">
  @tailwind utilities

  .no-cursor
    cursor: none

</style>
